export const DATE_COLUMNS = ['date']
export const DATE_TIME_COLUMNS = ['date time', 'date & time', 'call time', 'contacted time', 'starttime', 'endtime']

export const DATE_FORMAT = 'dd-MM-yyyy'
export const DATE_TIME_FORMAT = 'HH:mm:ss dd-MM-yyyy'
